export default "__VITE_ASSET__BSFyEfnI__"